document.addEventListener("DOMContentLoaded", async function () {

    const popup = document.getElementById("sales-popup");

    if (!popup) return;

    const city = document.getElementById("popup-city");
    const time = document.getElementById("popup-time");

    // Detect visitor city
    try {

        const res = await fetch("https://ipwho.is/");

        const data = await res.json();

        if (data.success && data.city) {

            city.innerText = data.city;

        }

    } catch (e) {

        city.innerText = "your city";

    }

    const times = [

        "2 minutes ago",
        "5 minutes ago",
        "8 minutes ago",
        "11 minutes ago",
        "16 minutes ago",
        "22 minutes ago",
        "31 minutes ago",
        "48 minutes ago",
        "1 hour ago",
        "2 hours ago"

    ];

    function randomTime(){

        time.innerText = times[Math.floor(Math.random()*times.length)];

    }

    function showPopup(){

        randomTime();

        popup.classList.add("show");

        setTimeout(()=>{

            popup.classList.remove("show");

        },5000);

    }

    setTimeout(showPopup,8000);

    setInterval(showPopup,25000);

});